/**
 * Logger intelligent - N'affiche RIEN en production
 */

const isProduction = process.env.NODE_ENV === 'production';

export const logger = {
  log: (...args) => {
    if (!isProduction) {
      console.log(...args);
    }
  },
  
  debug: (...args) => {
    if (!isProduction) {
      console.log('[DEBUG]', ...args);
    }
  },
  
  info: (...args) => {
    if (!isProduction) {
      console.info(...args);
    }
  },
  
  warn: (...args) => {
    // Warnings toujours affichés (même en prod)
    console.warn(...args);
  },
  
  error: (...args) => {
    // Erreurs toujours affichées (même en prod)
    console.error(...args);
  }
};

export default logger;
